import { generateUUID } from '../utils';
/** Mint a new row with a stable id — never derived from name/size/index. */ export function createPendingRow(file, overrides = {}) {
    return {
        id: generateUUID(),
        file,
        progress: 0,
        status: 'pending',
        contentType: file.type,
        ...overrides
    };
}
/** Replace exactly one row, addressed by id, leaving every other row's object identity untouched. */ export function replaceRow(rows, id, updater) {
    return rows.map((row)=>row.id === id ? updater(row) : row);
}
/** Replace exactly one row, addressed by id, with zero or more rows in its place — same
 *  position, archive order preserved. Used to swap an expanded archive row for its children. */ export function spliceRow(rows, id, replacements) {
    const index = rows.findIndex((row)=>row.id === id);
    if (index === -1) return rows;
    return [
        ...rows.slice(0, index),
        ...replacements,
        ...rows.slice(index + 1)
    ];
}
const ZIP_MIME_TYPES = new Set([
    'application/zip',
    'application/x-zip-compressed'
]);
/** Mirrors the server's ziputil.IsZip / IsZipFilename rule — mime type OR a .zip name. */ export function isZipFile(file) {
    return ZIP_MIME_TYPES.has(file.type) || file.name.toLowerCase().endsWith('.zip');
}
export function withUploading(row) {
    return {
        ...row,
        status: 'uploading',
        progress: 0
    };
}
export function withProgress(row, progress) {
    return {
        ...row,
        progress
    };
}
export function withUploaded(row, result) {
    return {
        ...row,
        status: 'uploaded',
        contentType: result.mimeType,
        jobId: result.jobId ?? null,
        attachmentId: result.artifactId,
        processingStatus: result.jobId ? 'processing' : 'ready',
        progress: 100
    };
}
export function withUploadError(row) {
    return {
        ...row,
        status: 'error'
    };
}
export function withProcessingStatus(row, processingStatus) {
    return {
        ...row,
        processingStatus
    };
}
